 
import CTNEllipsis from '@ctn/ui/components/ctn-ellipsis';
import { CTNIconTooltip } from '@ctn/ui/components/ctn-icon';

import TextIcon from '@/components/TextIcon';

import { getIconDocumento } from '@/helpers/upload';
import type { IDocumento } from '@/interfaces/model/don.interface';
import { type ILookup } from '@/interfaces/model/generic.interface';
import type { CustomColumnDef } from '@ctn/ui/types/ctn-table';

export const isSolicitanteOrigin = (origen?: ILookup) => {
	if (!origen) return true;
	return origen?.descripcion.toLowerCase() === 'pnm';
}; 

const getColumns = ({ hasColumnSubsanacion }: { hasColumnSubsanacion?: boolean }) => {
	const columns: Array<CustomColumnDef<IDocumento>> = [
		{
			accessorKey: 'tipoDocumento',
			header: 'Tipo documento',
			enableSorting: false,
			responsive: { sizeColumn: 'full' },
			cell({ row }) {
				// @ts-expect-error pass
				const error = !row.original.tipoDocumento?.vigente && row.original.tipoDocumento?.adicional;
				const { descripcion } = row.original.tipoDocumento;
				return (
					<CTNEllipsis
						content={error ? `${descripcion} (Tipo no valido)` : descripcion}
						className={error ? 'c-pnp-row__vigente' : ''}
					/>
				);
			},
		},
		{
			accessorKey: 'origen',
			header: 'Origen',
			enableSorting: false,
			responsive: { sizeColumn: 'full' },
			cell: ({ row }) => <CTNEllipsis content={isSolicitanteOrigin(row.original.origenDocumento) ? 'Solicitante' : 'Notaría'} />,
		},
		{
			accessorKey: 'nombre',
			header: 'Nombre documento',
			enableSorting: false,
			responsive: { sizeColumn: 'full' },
			cell: ({ row }) => (
				<TextIcon iconLeft={{ icon: getIconDocumento(row.original) }} description={row.original.nombre} />
			),
		},
		{
			accessorKey: 'tamano',
			header: 'Tamaño',
			enableSorting: false,
			th: {
				width: 100,
				align: 'right',
			},
			td: {
				align: 'right',
			},
			responsive: {
				sizeColumn: 'full',
			},
			cell({ getValue }) {
				const kiloBytesSize = Math.trunc(Number(getValue() as string) / 1024);
				return <CTNEllipsis content={String(kiloBytesSize) + ' Kb'} />;
			},
		},
	];

	if (hasColumnSubsanacion) {
		columns.unshift({
			accessorKey: 'subsanacionPendiente',
			header: 'Subs.',
			enableSorting: false,
			th: {
				width: 60,
			},
			responsive: {
				sizeColumn: 'full',
			},
			cell({ getValue }) {
				return (getValue() as IDocumento['subsanacionPendiente']) ? (
					<CTNIconTooltip icon="warning" color="orange-50" tooltip={{ content: 'Subsanación pendiente' }} />
				) : (
					<></>
				);
			},
		});
	}

	return columns;
};

export { getColumns };
